export enum FieldEventTypeEnums {
    /**
     * a normal checkbox was set/unset
     */
    CHECKBOX = 0,
    /**
     * a set all checkbox was set/unset
     */
    CHECKBOX_ALL = 1,
    /**
     * a number field with unit was set
     * trigger unit format check
     */
    CHECK_UNIT_FIELD = 3,

    /**
     * unknow/fallback
     */
    UNKNOWN = 999,
}
